import $ from 'jquery';
import AOS from 'aos';
import 'slick-carousel/slick/slick';

const getAjaxConfig = () => window.ajax || {};

const setContactMessage = ($form, message, type) => {
   const $message = $form.find('.home-contact-message');

   $message
      .removeClass('is-success is-error')
      .addClass(`is-visible is-${type}`)
      .text(message);
};

const MAX_REFERENCE_FILES = 2;
const MAX_REFERENCE_FILE_SIZE = 5 * 1024 * 1024;

const updateUploadList = (input) => {
   const files = Array.from(input.files || []);
   const $list = $(input).closest('label').siblings('.home-upload-list');

   $list.empty();

   files.forEach((file) => {
      const $item = $('<span />').addClass('home-upload-preview');
      const $name = $('<span />').addClass('home-upload-preview-name').text(file.name);

      if (file.type.startsWith('image/')) {
         const reader = new FileReader();
         const $image = $('<img />').attr('alt', '');

         reader.onload = (event) => {
            $image.attr('src', event.target.result);
         };

         reader.readAsDataURL(file);
         $item.append($image);
      }

      $item.append($name).appendTo($list);
   });
};

const setUploadFiles = (input, files) => {
   if (typeof DataTransfer === 'undefined') {
      return false;
   }

   const transfer = new DataTransfer();

   files.forEach((file) => transfer.items.add(file));
   input.files = transfer.files;

   return true;
};

const limitUploadFiles = (input, $form) => {
   const selected = Array.from(input.files || []);
   const valid = [];
   const errors = [];

   selected.forEach((file) => {
      if (!file.type.startsWith('image/')) {
         errors.push(`"${file.name}" is not a valid image.`);
         return;
      }

      if (file.size > MAX_REFERENCE_FILE_SIZE) {
         errors.push(`"${file.name}" exceeds the 5MB limit.`);
         return;
      }

      if (valid.length >= MAX_REFERENCE_FILES) {
         return;
      }

      valid.push(file);
   });

   if (selected.length > MAX_REFERENCE_FILES) {
      errors.push('You can add up to two images.');
   }

   setUploadFiles(input, valid);
   updateUploadList(input);

   if (errors.length && $form?.length) {
      setContactMessage($form, errors[0], 'error');
   } else if ($form?.length && $form.find('.home-contact-message').hasClass('is-error')) {
      $form.find('.home-contact-message').removeClass('is-visible is-error is-success').text('');
   }

   return valid.length === selected.length && errors.length === 0;
};

const initHomeSliders = () => {
   $('.home-hero-static video').each((_, video) => {
      video.play().catch(() => { });
   });

   $('.home-work-slider').not('.slick-initialized').slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 1750,
      centerMode: true,
      centerPadding: '12vw',
      dots: true,
      infinite: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      slidesToShow: 3,
      speed: 300,
      responsive: [
         {
            breakpoint: 1024,
            settings: {
               centerPadding: '8vw',
               slidesToShow: 2,
            },
         },
         {
            breakpoint: 768,
            settings: {
               centerMode: true,
               centerPadding: '16px',
               slidesToShow: 2,
            },
         },
      ],
   });

   $('.home-press-slider').each(function () {
      const $slider = $(this);
      const $wrap = $slider.closest('.home-press-slider-wrap');

      if ($slider.hasClass('slick-initialized')) {
         return;
      }

      $slider.slick({
         arrows: true,
         prevArrow: $wrap.find('.home-press-slider-arrow--prev'),
         nextArrow: $wrap.find('.home-press-slider-arrow--next'),
         dots: true,
         infinite: true,
         slidesToShow: 1,
         slidesToScroll: 1,
         speed: 700,
      });
   });

   window.setTimeout(() => {
      AOS.refreshHard();
   }, 250);
};

const openMobileMenu = () => {
   $('body').addClass('is-mobile-menu-open');
   $('.home-fixed-menu--hero .home-mobile-toggle').attr('aria-expanded', 'true');
   $('.home-mobile-menu').addClass('is-open').attr('aria-hidden', 'false');
};

const closeMobileMenu = () => {
   $('body').removeClass('is-mobile-menu-open');
   $('.home-mobile-toggle').attr('aria-expanded', 'false');
   $('.home-mobile-menu').removeClass('is-open').attr('aria-hidden', 'true');

   if (typeof window.rlmUpdateFixedMenu === 'function') {
      window.rlmUpdateFixedMenu();
   }
};

const initMobileMenu = () => {
   $('.home-fixed-menu--hero .home-mobile-toggle').on('click', function () {
      if ($('body').hasClass('is-mobile-menu-open')) {
         return;
      }

      openMobileMenu();
   });

   $('.home-mobile-close').on('click', closeMobileMenu);
   $('.home-mobile-menu a').on('click', closeMobileMenu);

   window.addEventListener('resize', () => {
      if (window.innerWidth >= 1024) {
         closeMobileMenu();
      }
   });
};

const initFixedMenu = () => {
   const $hero = $('#hero');
   const $menu = $('.home-fixed-menu--hero');

   if (!$hero.length || !$menu.length) {
      return;
   }

   let ticking = false;

   const update = () => {
      if ($('body').hasClass('is-mobile-menu-open')) {
         ticking = false;
         return;
      }

      const heroRect = $hero[0].getBoundingClientRect();

      if (heroRect.bottom <= 0) {
         $menu.addClass('is-pinned').css({ top: '', bottom: '' });
      } else {
         $menu
            .removeClass('is-pinned')
            .css({
               top: `${heroRect.bottom}px`,
               bottom: 'auto',
            });
      }

      ticking = false;
   };

   window.rlmUpdateFixedMenu = update;

   update();

   window.addEventListener('resize', update);

   window.addEventListener(
      'scroll',
      () => {
         if (ticking) {
            return;
         }

         window.requestAnimationFrame(update);
         ticking = true;
      },
      { passive: true },
   );
};

const initHeroFixedImage = () => {
   const $hero = $('#hero');
   const $static = $('.home-hero-static');
   const $image = $('.home-hero-image.js-hero-fixed');

   if (!$hero.length || !$image.length) {
      return;
   }

   if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
   }

   let ticking = false;

   const update = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      const heroRect = $hero[0].getBoundingClientRect();

      if (heroRect.bottom <= 0) {
         $static.addClass('is-past-hero');
         $image.css('transform', '');
      } else {
         $static.removeClass('is-past-hero');
         $image.css('transform', `translate3d(0, ${scrollY}px, 0)`);
      }

      ticking = false;
   };

   update();

   window.addEventListener('resize', update);

   window.addEventListener(
      'scroll',
      () => {
         if (ticking) {
            return;
         }

         window.requestAnimationFrame(update);
         ticking = true;
      },
      { passive: true },
   );
};

const initParallax = () => {
   const $items = $('.js-parallax');

   if (!$items.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
   }

   let ticking = false;

   const update = () => {
      const scrollY = window.scrollY || window.pageYOffset;

      $items.each((_, item) => {
         const speed = parseFloat(item.dataset.parallaxSpeed || '0.12');
         item.style.transform = `translate3d(0, ${scrollY * speed}px, 0) scale(1.08)`;
      });

      ticking = false;
   };

   update();

   window.addEventListener(
      'scroll',
      () => {
         if (ticking) {
            return;
         }

         window.requestAnimationFrame(update);
         ticking = true;
      },
      { passive: true },
   );
};

const initAos = () => {
   AOS.init({
      duration: 650,
      easing: 'ease-out-cubic',
      once: true,
      offset: 35,
      anchorPlacement: 'top-bottom',
   });

   window.addEventListener('load', () => {
      AOS.refreshHard();
   });
};

const closeGalleryModal = () => {
   const $modal = $('.home-gallery-modal');

   $('body').removeClass('is-gallery-modal-open');
   $modal.removeClass('is-open').attr('aria-hidden', 'true');

   window.setTimeout(() => {
      if (!$modal.hasClass('is-open')) {
         $modal.find('.home-gallery-modal-image').attr('src', '').attr('alt', '');
      }
   }, 300);
};

const initGalleryModal = () => {
   $('.home-gallery-trigger').on('click', function () {
      const imageUrl = this.dataset.fullImage;
      const imageAlt = this.dataset.imageAlt || '';

      if (!imageUrl) {
         return;
      }

      $('.home-gallery-modal-image').attr('src', imageUrl).attr('alt', imageAlt);
      $('body').addClass('is-gallery-modal-open');
      $('.home-gallery-modal').addClass('is-open').attr('aria-hidden', 'false');
   });

   $('.home-gallery-modal-close, .home-gallery-modal-backdrop').on('click', closeGalleryModal);

   $(document).on('keydown', (event) => {
      if (event.key === 'Escape' && $('.home-gallery-modal').hasClass('is-open')) {
         closeGalleryModal();
      }
   });
};

const initContactForm = () => {
   $('.home-upload-input').on('change', function () {
      const $form = $(this).closest('.home-contact-form');

      limitUploadFiles(this, $form);
   });

   $('.home-contact-form').on('submit', function (event) {
      event.preventDefault();

      const $form = $(this);
      const $button = $form.find('button[type="submit"]');
      const $uploadInput = $form.find('.home-upload-input').get(0);
      const ajaxConfig = getAjaxConfig();

      if ($uploadInput && !limitUploadFiles($uploadInput, $form)) {
         return;
      }

      const formData = new FormData(this);

      formData.set('nonce', ajaxConfig.ajaxNonce || formData.get('nonce'));

      $button.prop('disabled', true).text('Sending...');
      setContactMessage($form, 'Sending your request...', 'success');

      $.ajax({
         url: ajaxConfig.ajaxUrl,
         method: 'POST',
         data: formData,
         processData: false,
         contentType: false,
      })
         .done((response) => {
            const message = response?.data?.message || 'Thank you. Your request was sent successfully.';

            $form[0].reset();
            $form.find('.home-upload-list').empty();
            setContactMessage($form, message, 'success');
         })
         .fail((xhr) => {
            const message = xhr?.responseJSON?.data?.message || 'Something went wrong. Please try again in a moment.';

            setContactMessage($form, message, 'error');
         })
         .always(() => {
            $button.prop('disabled', false).text('Send');
         });
   });
};

const initSmoothScroll = () => {
   const normalizePath = (path) => path.replace(/\/$/, '') || '/';

   const scrollToTarget = (targetId, updateUrl = true) => {
      const $target = $(targetId);

      if (!targetId || targetId === '#' || !$target.length) {
         return false;
      }

      $('html, body').animate(
         {
            scrollTop: $target.offset().top,
         },
         900,
         'swing',
      );

      if (updateUrl) {
         window.history.pushState(null, '', targetId);
      }

      return true;
   };

   $('a[href*="#"]').on('click', function (event) {
      const url = new URL(this.href, window.location.href);

      if (normalizePath(url.pathname) !== normalizePath(window.location.pathname) || url.hostname !== window.location.hostname) {
         return;
      }

      if (scrollToTarget(url.hash)) {
         event.preventDefault();
         closeMobileMenu();
      }
   });

   if (window.location.hash) {
      window.setTimeout(() => {
         scrollToTarget(window.location.hash, false);
      }, 100);
   }
};

$(() => {
   initAos();
   initHomeSliders();
   initContactForm();
   initGalleryModal();
   initMobileMenu();
   initFixedMenu();
   initHeroFixedImage();
   initParallax();
   initSmoothScroll();
});
